import React from 'react'
import {Flex} from '@salesforce/retail-react-app/app/components/shared/ui'
import {Route, Switch, useRouteMatch} from 'react-router'
import RecipesList from '../../components/recipes-list'
import RecipeDetails from '../../components/recipe-details'

const RecipesPage = () => {
    const {path} = useRouteMatch()
    return (
        <Flex w="100%" flexDir="column" justifyContent="center" data-testid="recipes-parent-page">
            <Switch>
                <Route exact path={path}>
                    <RecipesList />
                </Route>
                <Route exact path={`${path}/:recipe_name/:recipe_id`}>
                    <RecipeDetails />
                </Route>
            </Switch>
        </Flex>
    )
}

export default RecipesPage
